

















import Vue from 'vue'
import QrScanner from 'qr-scanner'
import SeismicForm from '@/models/SeismicForm'
import sha1 from 'node-sha1'

export default Vue.extend({
  name: 'SimpleSyncrhonize',
  props: {
    campaign: { type: [Object, String] },
    teamName: { type: String, default: '' }
  },
  data () {
    return {
      qrScanner: null as null | QrScanner,
      active: false

    }
  },
  mounted () {
    this.qrScanner = new QrScanner(this.$el.querySelector('video') as HTMLVideoElement, result => {
      console.log('decoded qr code:', result)
      this.compareCurrentWith(JSON.parse(result.data))
      this.stop()
      this.$emit('close')
    }, { highlightScanRegion: true })
  },
  beforeDestroy () {
    this.stop()
  },
  methods: {
    start () {
      // eslint-disable-next-line no-unused-expressions
      this.qrScanner!.start()
      this.active = true
    },
    stop () {
      // eslint-disable-next-line no-unused-expressions
      this.qrScanner!.stop()
      this.active = false
    },
    compareCurrentWith (syncPayload: any) {
      console.log('SYNC STATUS', syncPayload, this.campaign)
      console.debug()
      if (syncPayload.title !== this.campaign.title) {
        console.log('Campagnes différentes !')
      } else if (this.calculateCheckSums(this.campaign as never) !== syncPayload.checksum) {
        console.log('wrong checksum')
      } else {
        syncPayload.modified.forEach((index: number) => {
          console.log('update sync status')
          Vue.set(this.campaign.forms[index], 'syncStatus', syncPayload.teamName)
        })
      }
    },
    // FIXME: Refactor this duplication in a dedicated file
    calculateCheckSums (campaign: never): string {
      const CAMPAIGN_CHECKSUM = sha1(Buffer.from((campaign as any).forms.map((item: SeismicForm) => item.numeroFiche).join('')))
      console.debug('calculateCheckSums', CAMPAIGN_CHECKSUM)
      return CAMPAIGN_CHECKSUM
    }
  }
})

